import {getOrGenerateAnonymousId} from '@vio/core/src/_web/anonymousId'
import {identifyWithMetaPixelCookies} from '@vio/core/src/_web/utils/cookies/pollForFbpCookie'
import {
  safelyGetStorageItem,
  safelySetStorageItem
} from '@vio/core/src/_web/utils/persistence'
import AnalyticsUtils from '@vio/core/src/analytics/utils'
import {Brand} from '@vio/core/src/brand/types'

const ANALYTICS_ENDPOINT = process.env.NEXT_PUBLIC_ANALYTICS_ENDPOINT
const API_KEY = process.env.NEXT_PUBLIC_ANALYTICS_API_KEY
const GTM_CONTAINER_ID = process.env.NEXT_PUBLIC_GTM_ID
const getLogEvents = () =>
  safelyGetStorageItem(localStorage, 'logEvents', 'getLogEvents failed')

const setLogEvents = (logEvents: string): void =>
  safelySetStorageItem(
    localStorage,
    'logEvents',
    logEvents,
    'setLogEvents failed'
  )
const initializeSDK = (brand: Brand) => {
  const integrations = {
    'Segment.io': {
      apiKey: API_KEY,
      apiHost: ANALYTICS_ENDPOINT
    },
    'Google Tag Manager': {
      containerId: brand.analytics?.gtm?.containerId || GTM_CONTAINER_ID,
      // This prevents double page view tracking
      trackCategorizedPages: false
    }
  }
  // Switch for easier debugging
  const logEventsParam = new URLSearchParams(window.location.search).get(
    'logEvents'
  )
  if (logEventsParam) setLogEvents(logEventsParam)
  const logEvents = getLogEvents() === '1'

  AnalyticsUtils.setLogEventsStatus(logEvents)
  AnalyticsUtils.initialize(integrations, getOrGenerateAnonymousId())
  /** Meta pixel cookies. Helpful for retargeting.
   * https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
   */
  identifyWithMetaPixelCookies(({fbp, fbc}) => {
    AnalyticsUtils.identify(undefined, {fbp, fbc})
  })
}

export default initializeSDK
